import {
  DocRevisionInSignFlowFragment,
  ExpDocRevAgreementFormForSessionInSignFlowFragment,
} from 'src/lib/gql-client'

type DocRevisionInSignFlow_ExplanationDocRevisionAgreementForm_Fragment =
  DocRevisionInSignFlowFragment & {
    __typename: 'ExplanationDocRevisionAgreementForm'
  }

export const isDocRevCompleted = (
  docRev:
    | DocRevisionInSignFlowFragment
    | ExpDocRevAgreementFormForSessionInSignFlowFragment,
) => {
  if (docRev.__typename === 'ExplanationDocRevisionAgreementForm') {
    const isRejected = docRev.signHistories.some(h => h.isRejected)
    // 署名するメンバー+患者が署名ずみか判定
    const allSigned =
      docRev.signHistories.length === docRev.signerMembers.length + 1
    return isRejected || allSigned
  }

  return !!docRev.latestPatientSideBrowsingHistory
}

export const hasSigningNotRequiredAgreements: (
  agreementForms:
    | DocRevisionInSignFlow_ExplanationDocRevisionAgreementForm_Fragment[]
    | ExpDocRevAgreementFormForSessionInSignFlowFragment[],
) => boolean = agreementForms => {
  return (
    agreementForms.filter(
      af =>
        !af.isPatientConsentRequired &&
        !!af.docusignEnvelopeId &&
        !isDocRevCompleted(af),
    ).length > 0
  )
}

/**
 * 署名が完了していない任意同意書（envelope の有無を問わない）を返す。
 * 「未着手」も含めて検出する点が hasSigningNotRequiredAgreements と異なる。
 */
export const getNotCompletedOptionalAgreementForms = <
  T extends
    | DocRevisionInSignFlow_ExplanationDocRevisionAgreementForm_Fragment
    | ExpDocRevAgreementFormForSessionInSignFlowFragment,
>(
  agreementForms: T[],
): T[] => {
  return agreementForms.filter(
    af => !af.isPatientConsentRequired && !isDocRevCompleted(af),
  )
}

/**
 * 未完了の文書を「署名が未完了の同意書」と「閲覧が未完了の説明文書」に分割する。
 */
export const splitNotCompletedDocRevisions = (
  docRevs: DocRevisionInSignFlowFragment[],
): {
  agreementForms: DocRevisionInSignFlow_ExplanationDocRevisionAgreementForm_Fragment[]
  browsingDocs: Exclude<
    DocRevisionInSignFlowFragment,
    DocRevisionInSignFlow_ExplanationDocRevisionAgreementForm_Fragment
  >[]
} => {
  const agreementForms: DocRevisionInSignFlow_ExplanationDocRevisionAgreementForm_Fragment[] =
    []
  const browsingDocs: Exclude<
    DocRevisionInSignFlowFragment,
    DocRevisionInSignFlow_ExplanationDocRevisionAgreementForm_Fragment
  >[] = []

  for (const docRev of docRevs) {
    if (docRev.__typename === 'ExplanationDocRevisionAgreementForm') {
      agreementForms.push(docRev)
    } else {
      browsingDocs.push(docRev)
    }
  }

  return { agreementForms, browsingDocs }
}
